<template>
    <div>
        <div class="">
            <header class="text-left search_equipment px-3 py-3">
                    <b-img :src="require('@/assets/small-logo.png')" width="35" height="40"></b-img>
            </header>
        </div>
        <div>
            <b-modal id="searchModal" centered hide-footer :title="$t('driverSearchPage.modalTitle')" :no-close-on-backdrop="true" size="sm" no-close-on-esc>
                <template #modal-header="{ close }">
                    <h5 class="modal-title">{{ $t('driverSearchPage.headerTitle') }}</h5>
                    <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                        {{ $t('driverSearchPage.closeModal') }}
                    </b-button>
                </template>
                <div class="d-block text-center">
                    <b-row>
                        <b-col cols="12">
                            <b-form @submit.prevent="handleFormSubmit">
                                <b-form-group :label="$t('driverSearchPage.driverIdLabel')" class="text-left">
                                    <b-form-input type="text" v-model="form.driver_id" :placeholder="$t('driverSearchPage.driverIdPlaceholder')"
                                        required></b-form-input>
                                    <p v-if="errors.driver_id" class="field-error">
                                        {{ $t('driverSearchPage.fieldRequired') }}
                                    </p>
                                </b-form-group>
                                <b-button type="submit" class="save w-100" variant="primary">{{ $t('driverSearchPage.submit') }}</b-button>
                            </b-form>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
        </div>
    </div>
</template>
  
<script>
import { mapActions } from "vuex";
export default {
    name: "driver-search",
    data() {
        return {
            errors: {
                driver_id: false,
            },
            form: {
                driver_id: "",
            },
        };
    },
    methods: {
        ...mapActions(["setNotification", "checkDriverStatus"]),
        async handleFormSubmit() {
            try {
                const status = await this.checkDriverStatus({id:this.form.driver_id});
                if(status) this.$router.push(`/driver-details?driver=${this.form.driver_id}`)
                else this.setNotification({
                    msg: this.$t('driverSearchPage.driverNotFound'),
                    type: "error",
                    color: "red",
                });
                // this.$bvModal.hide("searchModal");
            } catch (e) {
                console.log(e)
            }
        },
    },
    async mounted() {
        this.$bvModal.show("searchModal");
    },
};
</script>